export default __webpack_public_path__ + "static/media/img_chart_grade_S0.43f2d520d35eb52931be3975d6f3d3b6.svg";